import * as React from 'react';
import {Trans} from '@lingui/macro';
import {useLingui} from '@lingui/react';
import {useSelector} from 'react-redux';
import {Route, Switch} from 'react-router';
import Driver from 'driver.js';

import Dialog from '@components/Dialog';
import FlatButton from '@components/FlatButton';

import useMedia from '@hooks/useMediaQuery';

import 'driver.js/dist/driver.min.css';
import s from './CalendarTutorial.module.css';

export default function CalendarTutorial({isOpen, close, selectedTest}) {
  const driver = useDriverInstance({onReset: close});
  const {i18n} = useLingui();

  const [location, setLocation] = React.useState('INTRO');

  const isMobile = useMedia('(max-width: 600px)');

  function startTutorial() {
    setLocation('TUTORIAL');

    if (driver) {
      driver.defineSteps([
        {
          element: '#sk-calendar-today',
          popover: {
            className: 'first-step-popover-class',
            title: i18n._('calendar.tutorial_agenda_title'),
            description: i18n._('calendar.tutorial_firststep'),
            position: !isMobile ? 'left' : 'bottom',
          },
        },
        {
          element: '.sk-calendar-daybox',
          popover: {
            className: 'first-step-popover-class',
            title: i18n._('calendar.tutorial_agenda_title'),
            description: i18n._('calendar.tutorial_secondstep'),
            position: isMobile ? 'top' : 'left',
          },
          onNext: () => {
            const dayBoxButton = isMobile
              ? document.querySelector('.sk-calendar-daybox')
              : document.querySelector('.sk-calendar-daybox button');
            dayBoxButton.click();
          },
        },
        {
          element: '#sk-calendar-sidebar',
          popover: {
            className: 'first-step-popover-class',
            title: i18n._('calendar.tutorial_agenda_title'),
            description: i18n._('calendar.tutorial_thirdstep'),
            position: isMobile ? 'bottom' : 'right',
          },
          offset: isMobile ? 20 : 0,
          onNext: () => {
            const dayBoxButton = isMobile
              ? document.querySelector('.sk-calendar-daybox')
              : document.querySelector('.sk-calendar-daybox button');
            dayBoxButton.click();
          },
        },
        {
          element: '#sk-calendar-footer',
          popover: {
            className: 'first-step-popover-class',
            title: i18n._('calendar.tutorial_activities_title'),
            description: i18n._('calendar.tutorial_fourthstep'),
            position: 'top',
          },
          onNext: () => {
            const dayBoxButton = isMobile
              ? document.querySelector('.sk-calendar-daybox')
              : document.querySelector('.sk-calendar-daybox button');
            dayBoxButton.click();

            document.querySelector('.driver-popover-description').innerHTML = i18n._(
              'calendar.tutorial_fifthstep'
            );

            const footer = document.querySelector('#sk-calendar-footer');
            footer.classList.add('driver-highlighted-element');
          },
          offset: isMobile ? 20 : 0,
        },
        {
          element: '#sk-calendar-footer',
          popover: {
            className: 'first-step-popover-class',
            title: i18n._('calendar.tutorial_activities_title'),
            description: i18n._('calendar.tutorial_fifthstep'),
            position: 'top',
          },
          onNext: () => {
            const miniCalendarOpener = document.querySelector('#sk-calendar-sidebar button');
            driver.preventMove();

            if (miniCalendarOpener) miniCalendarOpener.click();

            setTimeout(() => {
              driver.moveNext();
            }, 0);
          },
          offset: isMobile ? 20 : 0,
        },
        {
          element: '#sk-calendar-sidebar',
          popover: {
            className: 'first-step-popover-class',
            title: i18n._('calendar.tutorial_activities_title'),
            description: i18n._('calendar.tutorial_sixstep'),
            position: isMobile ? 'bottom' : 'right',
          },
          onNext: () => {
            const miniCalendarOpener = document.querySelector('#sk-calendar-sidebar button');
            if (!isMobile && miniCalendarOpener) miniCalendarOpener.click();

            document.querySelector('.driver-popover-description').innerHTML = i18n._(
              'calendar.tutorial_sevenstep'
            );
          },
          offset: isMobile ? 20 : 0,
        },
        {
          element: '#sk-calendar-sidebar',
          popover: {
            className: 'first-step-popover-class',
            title: i18n._('calendar.tutorial_activities_title'),
            description: i18n._('calendar.tutorial_sevenstep'),
            position: isMobile ? 'bottom' : 'right',
          },
          onNext: () => {
            const dayBoxButton = isMobile
              ? document.querySelector('.sk-calendar-daybox')
              : document.querySelector('.sk-calendar-daybox button');
            dayBoxButton.click();
          },
          offset: isMobile ? 20 : 0,
        },
        {
          element: '.sk-calendar-prerequisite',
          popover: {
            className: 'first-step-popover-class',
            title: i18n._('calendar.tutorial_activities_title'),
            description: i18n._('calendar.tutorial_eightstep'),
            position: isMobile ? 'top' : 'right',
          },
        },
        {
          element: '#rewatch-tutorial-btn',
          popover: {
            className: 'first-step-popover-class',
            title: 'Tutorial',
            description: i18n._('calendar.tutorial_ninestep'),
            position: isMobile ? 'top' : 'right',
          },
          onNext: () => {
            setLocation('FINAL');
          },
        },
      ]);

      driver.start();
    }
  }

  const userFirstName = useSelector(state => state.getIn(['user', 'data', 'firstName']));
  const campaignData = useSelector(state => {
    return state.getIn(['userCampaign', 'data', 'data']);
  });

  return (
    <Switch location={{pathname: location}}>
      <Route path="INTRO">
        <Dialog
          isOpen={isOpen}
          overlayClassName={s.TutorialDialogBackdrop}
          className={s.TutorialDialog}
        >
          <div className={s.Intro}>
            <h1>
              <Trans id="calendar.welcome">Buongiorno</Trans>, {userFirstName}.
            </h1>
            <div className={s.Padding}>
              {campaignData.get('intro') ? (
                <div>
                  <div dangerouslySetInnerHTML={{__html: campaignData.get('intro')}} />
                  <FlatButton onClick={() => setLocation('VIDEO')}>
                    <Trans id="calendar.start_tut">GUARDA IL TUTORIAL</Trans>
                  </FlatButton>
                </div>
              ) : (
                <div>
                  <h2>Benvenuto nella tua agenda.</h2>
                  <p className={s.Description}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas egestas tellus
                    nunc, non scelerisque ex maximus at. Pellentesque pulvinar odio eget risus
                    tristique maximus. Pellentesque ac elit fringilla, gravida velit eu, aliquam
                    quam. Cras bibendum turpis fermentum rutrum vulputate.
                  </p>
                  <p className={s.Description}>
                    Guarda il video tutorial e inizia le tue attività!
                  </p>
                  <FlatButton onClick={() => setLocation('VIDEO')}>
                    <Trans id="calendar.start_tut">GUARDA IL TUTORIAL</Trans>
                  </FlatButton>
                </div>
              )}
            </div>
          </div>
        </Dialog>
      </Route>

      <Route path="VIDEO">
        <Dialog isOpen={isOpen} overlayClassName={s.VideoOverlay} className={s.VideoDialog}>
          <div>
            <Trans id="calendar.tut_intro">
              M-SkillUp è l’innovativo sistema di assessment che ti permette di mettere alla prova
              le tue competenze e abilità. Scopri come utilizzarlo al meglio! Mettiti in gioco nelle
              attività che ti vengono proposte nella tua agenda mensile, vivendo un’esperienza
              simulata in cui assumerai il ruolo di consulente.
            </Trans>
          </div>

          <FlatButton onClick={startTutorial}>
            <Trans id="calendar.goon">Avanti</Trans>
          </FlatButton>
        </Dialog>
      </Route>

      <Route path="TUTORIAL" />

      <Route path="FINAL">
        <Dialog isOpen={isOpen} overlayClassName={s.VideoOverlay} className={s.VideoDialog}>
          <div>
            <Trans id="calendar.tutorial_end">
              Ora sei pronto per iniziare a svolgere le attività della tua agenda! Buon lavoro!
            </Trans>
          </div>

          <FlatButton onClick={close}>
            <Trans id="calendar.start">Inizia</Trans>
          </FlatButton>
        </Dialog>
      </Route>
    </Switch>
  );
}

function useDriverInstance({onReset}) {
  const mainDriverRef = React.useRef(null);

  React.useEffect(() => {
    mainDriverRef.current = new Driver({
      allowClose: false,
      opacity: 0.6,
      prevBtnText: 'Prev',
      onReset,
    });
  }, []);

  return mainDriverRef.current;
}
